module.exports = __webpack_public_path__ + "static/media/29-1.0e42aab7.mp3";